function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class TimerApi {
    initialize() {
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
    }
    start() {
        if (this.timerId === null) {
            this.timerId = setTimeout(()=>{
                var _this_onElapsedCallback, _this;
                (_this_onElapsedCallback = (_this = this).onElapsedCallback) === null || _this_onElapsedCallback === void 0 ? void 0 : _this_onElapsedCallback.call(_this);
            }, this.duration);
        }
    }
    stop() {
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
    }
    onElapsed(callback) {
        this.onElapsedCallback = callback;
    }
    constructor(duration){
        _define_property(this, "duration", void 0);
        _define_property(this, "timerId", void 0);
        _define_property(this, "onElapsedCallback", void 0);
        this.duration = duration;
        this.timerId = null;
        this.onElapsedCallback = null;
    }
}
